// 保存该模块下的路由信息
const routerArr = [
	{
		path: '/login_new',
		name: 'login',
		meta: { title: '登录', login: false },
		component: () => import(/* webpackChunkName: 'login' */ './login/login.vue'),
	},
	{
		path: '/register_new',
		name: 'register',
		meta: { title: '注册', login: false },
		component: () => import(/* webpackChunkName: 'register' */ './register/register.vue'),
	},
	{
		path: '/forget',
		name: 'forget',
		meta: { title: '忘记密码', login: false },
		component: () => import(/* webpackChunkName: 'forget' */ './forget/forget.vue'),
	},
	{
		path: '/resetPassword_new',
		name: 'resetPassword_new',
		meta: { title: '忘记密码', login: false },
		component: () => import(/* webpackChunkName: 'forget' */ './forget/resetPassword_new.vue'),
	},
	{
		path: '/personAccount_new',
		name: 'personAccount',
		meta: { title: '账号安全', login: true },
		component: () => import(/* webpackChunkName: 'personAccount' */ './accountSecurity/accountSecurity.vue'),
	},
	{
		path: '/modifyPassword_new',
		name: 'modifyPassword',
		meta: { title: '修改密码', login: true },
		component: () => import(/* webpackChunkName: 'modifyPassword' */ './accountSecurity/modifyPassword.vue'),
	},
	{
		path: '/modifyPhone_new',
		name: 'modifyPhone',
		meta: { title: '绑定/更换手机', login: true },
		component: () => import(/* webpackChunkName: 'modifyPhone' */ './accountSecurity/modifyPhone.vue'),
	},
	{
		path: '/modifyMail_new',
		name: 'modifyMail',
		meta: { title: '绑定/更换邮箱', login: true },
		component: () => import(/* webpackChunkName: 'modifyMail' */ './accountSecurity/modifyMail.vue'),
	},
	{
		path: '/personalCenter_new',
		name: 'personalCenter_new',
		meta: { title: '个人中心', login: true },
		component: () => import(/* webpackChunkName: 'personalCenter_new' */ './personalCenter/personalCenter.vue'),
    },
    {
		path: '/setting_new',
		name: 'setting_new',
		meta: { title: '设置', login: true },
		component: () => import(/* webpackChunkName: 'setting' */ './personalCenter/setting.vue'),
    },
    {
		path: '/edit_new',
		name: 'edit_new',
		meta: { title: '编辑', login: true },
		component: () => import(/* webpackChunkName: 'edit_new' */ './personalCenter/edit.vue'),
    },
    {
        path: '/myProfile_new',
        name: 'myProfile_new',
        meta: { title:'我的资料',login:true },
        component: () => import(/* webpackChunkName: 'myProfile_new' */ './personalCenter/userInfo.vue'),
      },
]
export default routerArr
